module.exports = __webpack_public_path__ + "static/media/favorites.8cf39abf.jpg";